@if (chartsCountSg() === 1) {
  <!-- In case that there is only one chart, we want to display it on whole
  widget, and to avoid calculations for grid layout, only one chart is displayed
  without any classes-->
  <atn-ds-chart [chart]="chartsSg()[0]" />
} @else {
  <div
    #vennChartsContainer
    class="venn-chart-grid-container"
    [style.--venn-chart--min-width]="minWidth"
    [style.--venn-chart--min-height]="minHeight"
    [style.--venn-charts--max-columns]="columnsCountSg()"
    [style.--venn-charts--rows]="rowsCountSg()"
    [style.--venn-chart--container-height]="containerHeightSg()"
  >
    @for (chart of chartsSg(); track $index) {
      <atn-ds-chart [chart]="chart" />
    }
  </div>
}
